import api from "./api";

const totpService = {};

totpService.verify = function (userId, medicalService, token, checkPatient) {
  return api
    .post("/totp/verify", { userId, medicalService, token, checkPatient })
    .then((res) => res.data);
};

export default totpService;
